import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SolicitudModificacionService {

  token: string = '';
  baseUrl = environment.apiEndpoint;



  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getListSolicitudByEstadoId(id: string, estadoId: number, tipoId: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listSolicitudByEstadoId/' + id + '/' + estadoId + '/' + tipoId, { headers: this.header(this.token) });
  }

  getListSolicitudByEstadoIdA(estadoId: number): Observable<any> {
    return this.http.get(this.baseUrl + 'listSolicitudByEstadoIdA/' + estadoId, { headers: this.header(this.token) });
  }

  getListSolicitudByEstadoAprobar(estadoId: number): Observable<any> {
    return this.http.get(this.baseUrl + 'listSolicitudByEstadoAprobar/' + estadoId, { headers: this.header(this.token) });
  }
  
  getDatosFusById(id: number, tipoSolicitud: number): Observable<any> {    
    return this.http.get(this.baseUrl + 'datosFusById/' + id + '/' + tipoSolicitud, { headers: this.header(this.token) });
  }

  getDatosSolicitudDetalle(id: number, idFus: number): Observable<any> {
    return this.http.get(this.baseUrl + 'datosSolicitudDetalle/' + id + '/' + idFus, { headers: this.header(this.token) });
  }


  getListFusSolicitud(id: string, tipoId: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listFusSolicitud/' + id + '/' + tipoId, { headers: this.header(this.token) });
  }

  deleteSolicitud(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'solicitud/' + id, { headers: this.header(this.token) });
  }


  postFusSolicitud(data: any): Observable<any> {
    return this.http.post(this.baseUrl + 'solicitudModificacion', data, { headers: this.header(this.token) });
  }

  putFusSolicitud(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'solicitudModificacion', bodyString, { headers: this.header(this.token) });
  }

  putCambiosEstadoSolicitud(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);    
    return this.http.put(this.baseUrl + 'cambioEstadoModificacion', bodyString, { headers: this.header(this.token) });
  }

  putCambiosEstadoSolicitudJue(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'cambioEstadoModificacionJue', bodyString, { headers: this.header(this.token) });
  }

  getSeguimientoByPacId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'seguimientoByPacId/' + id, { headers: this.header(this.token) });
  }

  postModificacionFUS(data: any): Observable<any> {
    return this.http.post(this.baseUrl + 'postModificacionFUS', data, { headers: this.header(this.token) });
  }

  getSeguimientoBySolicitudId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'seguimientoBySolicitudId/' + id, { headers: this.header(this.token) });
  }
  

}

